// material
import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import Footer from '../components/Footer';
import Page from '../components/Page';
import LandingBody from '../components/_landingpage/LandingBody';
import Header from '../components/_landingpage/LandingHeader';
import LandingPartner from '../components/_landingpage/LandingPartner';
import LandingSection from '../components/_landingpage/LandingSection';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function LandingPage({ user }) {
  return (
    <Page title="Peladen Pemda DIY">
      <Header user={user} />
      <LandingBody />
      <LandingPartner />
      <LandingSection user={user} />
      <Footer user={user} />
    </Page>
  );
}
